/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { countryCodes } from '@/constants/locale';
import {
  defaultSortingOptions,
  defaultSortingOptionsForMX,
  defaultSortingOptionsForBR,
  defaultAcesSortingOptions,
  defaultAcesSortingOptionsForBR,
  defaultAcesSortingOptionsForMX,
} from '../constants';
import { type Locale } from '@/types/i18n';

export const getDefaultSortingOptions = (shouldUseAcesSortingOptions: boolean, locale?: Locale) => {
  if (locale === countryCodes.mx) {
    return shouldUseAcesSortingOptions
      ? defaultAcesSortingOptionsForMX
      : defaultSortingOptionsForMX;
  } else if (locale === countryCodes.ptBr) {
    return shouldUseAcesSortingOptions
      ? defaultAcesSortingOptionsForBR
      : defaultSortingOptionsForBR;
  }

  return shouldUseAcesSortingOptions ? defaultAcesSortingOptions : defaultSortingOptions;
};
